import { useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";

export default function Services() {
  const navigate = useNavigate();

  const items = [
    { img: "/assets/cash-loan.jpg", label: "قرض نقدي", type: "cash" },
    { img: "/assets/auto-loan.jpg", label: "قرض سياره", type: "auto" },
    { img: "/assets/bus.jpg", label: "قرض الشركات", type: "business" },
    { img: "/assets/retiree.jpg", label: "قرض المتقاعدين", type: "retiree" },
  ];

  const slideRef = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.innerWidth < 768 && slideRef.current) {
        slideRef.current.scrollBy({
          left: slideRef.current.offsetWidth,
          behavior: "smooth",
        });
        if (
          slideRef.current.scrollLeft + slideRef.current.offsetWidth >=
          slideRef.current.scrollWidth
        ) {
          slideRef.current.scrollTo({ left: 0, behavior: "smooth" });
        }
      }
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const offers = [
    { img: "/assets/img/kh4.jpeg", title: "عرض القروض التعليمية", href: "/" },
    { img: "/assets/img/kh5.jpeg", title: "عرض القروض الإسكانية", href: "/" },
    { img: "/assets/img/kh6.jpeg", title: "عرض قروض السيارات", href: "/" },
  ];

  return (
    <section id="homeServices" className="px-4 lg:px-12 py-8">
      {/* قسم القروض */}
      <div className="mx-auto max-w-[1700px] bg-[#F3F4F6] rounded-3xl p-6 md:p-8">
        <p className="text-[#00A3E0] font-semibold text-center mb-4">
          أحسب قرضك
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6">
          {items.map((x) => (
            <article
              key={x.label}
              onClick={() => navigate(`/calculate?type=${x.type}`)}
              className="cursor-pointer bg-white rounded-lg shadow-md hover:shadow-lg transition hover:scale-[0.98] flex flex-col items-center justify-center p-4"
            >
              <div className="relative w-[100px] h-[86px] overflow-hidden rounded-md">
                <img
                  src={x.img}
                  alt={x.label}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mt-3 text-sm font-medium text-[#0f172a]">
                {x.label}
              </p>
            </article>
          ))}
        </div>
      </div>

      {/* لماذا تختارنا */}
      <div className="mt-8 lg:flex items-center justify-between gap-8 bg-[#F3F4F6] rounded-3xl p-6">
        <div className="lg:w-[70%] space-y-4">
          <h3 className="text-xl font-semibold">لماذا تختارنا ؟</h3>
          <p className="text-md">
            مرحباً بكم في شركة التسهيلات، حيث رضاؤكم هو أولويتنا. اكتشف لماذا
            اختيارنا هو القرار الأفضل لتوفير جميع احتياجاتك الائتمانية.
          </p>
          <a
            href="/"
            className="text-[#00A3E0] underline underline-offset-4"
          >
            اقرأ المزيد &gt;
          </a>
        </div>
        <div className="mt-6 lg:mt-0 lg:w-[30%]">
          <img
            src="/assets/section1-cover-ar.png"
            alt="cover"
            className="rounded-2xl w-full"
          />
        </div>
      </div>

      {/* عروض التسهيلات */}
      <div className="mt-10 bg-[#F3F4F6] rounded-3xl p-6 pb-4">
        <div className="text-center mb-6">
          <p className="text-[#00A3E0] font-semibold">عروض التسهيلات</p>
          <p className="text-lg">آخر العروض</p>
        </div>

        <div
          ref={slideRef}
          className="flex md:grid md:grid-cols-3 gap-6 overflow-x-auto md:overflow-visible scroll-smooth snap-x snap-mandatory"
        >
          {offers.map((c) => (
            <div
              key={c.title}
              className="bg-white rounded-2xl shadow hover:shadow-lg transition overflow-hidden min-w-[85%] md:min-w-0 snap-start"
            >
              <div className="w-full overflow-hidden flex justify-center items-center">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-[220px] md:h-[360px] object-cover rounded-t-2xl transition-transform duration-500 hover:scale-[1.02]"
                />
              </div>

              <div className="flex items-center justify-between px-4 py-3">
                <p className="font-medium text-sm text-[#0f172a]">
                  {c.title}
                </p>
                <a
                  href={c.href}
                  className="rounded-md bg-[#00A3E0] px-3 py-1.5 text-white text-sm"
                >
                  عرض المزيد
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
